import { Injectable } from '@angular/core';
import { MessageTypeEnum } from '@app/ngrx-message/constants/messageTypeEnum';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@shared/services/toast/toast.service';
import { tap } from 'rxjs';

import {
  SERVICE_REQUEST_ACTIONS,
  SUPPORT_CENTER_ACTIONS,
} from '@usf/ngrx-list';

@Injectable({
  providedIn: 'root',
})
export class supportCenterEffects {
  resubmitSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SERVICE_REQUEST_ACTIONS.resubmitSuccess),
        tap(action => {
          this.toastService.presentToastMsg(
            this.translateService.instant(
              'i18n.supportCenter.request.resubmitSuccess',
            ),
            'green-toast',
            MessageTypeEnum.success,
            [],
          );
          console.log('should see a toast');
        }),
      ),
    { dispatch: false },
  );

  resubmitFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SERVICE_REQUEST_ACTIONS.resubmitFail),
        tap(action => {
          this.toastService.presentToastMsg(
            this.translateService.instant(
              'i18n.supportCenter.request.resubmitFail',
            ),
            'red-toast',
            MessageTypeEnum.failure,
            [],
          );
        }),
      ),
    { dispatch: false },
  );

  submitSupportRequestSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SUPPORT_CENTER_ACTIONS.submitSupportRequestSuccess),
        tap(action => {
          this.toastService.presentToastMsg(
            this.translateService.instant(
              'i18n.supportCenter.requestModal.submitSuccess',
            ),
            'green-toast',
            MessageTypeEnum.success,
            [],
          );
        }),
      ),
    { dispatch: false },
  );

  submitSupportRequestFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SUPPORT_CENTER_ACTIONS.submitSupportRequestFailure),
        tap(action => {
          this.toastService.presentToastMsg(
            this.translateService.instant(
              'i18n.supportCenter.requestModal.submitFailure',
            ),
            'red-toast',
            MessageTypeEnum.failure,
            [],
          );
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private toastService: ToastService,
    private translateService: TranslateService,
  ) {}
}
